import { Component, inject, Input, PLATFORM_ID, signal } from '@angular/core';
import { ITeamMember } from '../../../../shared/interfaces/team.interface';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Button } from '../../../../shared/components/button/button';

@Component({
  selector: 'app-team-card',
  imports: [CommonModule, Button],
  templateUrl: './team-card.html',
  styleUrl: './team-card.scss'
})
export class TeamCard {

  protected showMore = signal(false);
  protected showFront = signal(true);
  @Input() teamMember!: ITeamMember

  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  rotate() {
    this.showMore.update((show) => !show);

    if (this.isBrowser) {
      setTimeout(() => {
        this.showFront.update((v) => !v);
      }, 400);
    } else {
      this.showFront.set(true);
    }
  }

}
